import { ActionTypes } from 'redux-plupload';

export const uploaderInit = (options) => dispatch =>
  dispatch({ type: ActionTypes.INIT, payload: options })

export const removeFile = (file) => dispatch =>
  dispatch({ type: ActionTypes.REMOVE_FILE, payload: { file } })

export const startUpload = () => dispatch =>
  dispatch({ type: ActionTypes.START })

export const setOption = (payload) => dispatch =>
  dispatch({ type: ActionTypes.SET_OPTION, payload })

export const destroy = () => dispatch =>
  dispatch({ type: ActionTypes.DESTROY })

